import { useState, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  Typography,
} from "antd";
import Echart from "../components/chart/EChart";
import {
  ShoppingCartOutlined,
  HeartOutlined,
  TeamOutlined,
} from "@ant-design/icons";

function Home() {
  const { Title } = Typography;
  const userId = localStorage.getItem("userId");

  // Dashboard Stats State
  const [stats, setStats] = useState({
    sales: 0,
    orders: 0,
    users: 0, // Will be connected later
  });

  const [loading, setLoading] = useState(false);

  // 🚀 Fetch Dashboard Stats from Backend (FAST ENDPOINT)
  useEffect(() => {
    if (!userId) return;

    setLoading(true);

    fetch("http://localhost:8080/orders/stats")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch dashboard stats");
        }
        return response.json();
      })
      .then((data) => {
        setStats({
          sales: data.totalSales || 0,
          orders: data.totalOrders || 0,
          users: 0, // Placeholder for Users API
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading dashboard data:", error);
        setLoading(false);
      });
  }, [userId]);

  const rupeeIcon = (
    <span style={{ fontSize: "20px", fontWeight: "bold" }}>₹</span>
  );

  // Dashboard Cards Data
  const count = [
    {
      today: "Total Sales",
      title: `₹${stats.sales.toLocaleString()}`,
      persent: "+5%",
      icon: rupeeIcon,
      bnb: "bnb2",
    },
    {
      today: "Total Orders",
      title: stats.orders,
      persent: "+10%",
      icon: <ShoppingCartOutlined />,
      bnb: "bnb2",
    },
    {
      today: "New Users",
      title: stats.users,
      persent: "0%",
      icon: <TeamOutlined />,
      bnb: "redtext",
    },
    {
      today: "Growth",
      title: "Active",
      persent: "",
      icon: <HeartOutlined />,
      bnb: "bnb2",
    },
  ];

  return (
    <>
      {userId ? (
        <div className="layout-content">
          <Row className="rowgap-vbox" gutter={[24, 0]}>
            {count.map((c, index) => (
              <Col
                key={index}
                xs={24}
                sm={24}
                md={12}
                lg={6}
                xl={6}
                className="mb-24"
              >
                <Card bordered={false} className="criclebox">
                  <div className="number">
                    <Row align="middle" gutter={[24, 0]}>
                      <Col xs={18}>
                        <span>{c.today}</span>
                        <Title level={3}>
                          {c.title}{" "}
                          <small className={c.bnb}>{c.persent}</small>
                        </Title>
                      </Col>
                      <Col xs={6}>
                        <div className="icon-box">{c.icon}</div>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
              <Card bordered={false} className="criclebox h-full">
                <Echart />
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <span
          style={{
            fontSize: "20px",
            background: "white",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          Sign in to see admin dashboard
        </span>
      )}
    </>
  );
}

export default Home;
